export default function Caa() {
    return (
        <div className="hp-flex">
            <div className="hp-l">
                <div>
                    <h1>Credits & Acknowledgement</h1>
                    <div>Because Everything got a story to tell</div> 
                </div>
                <div>
                    <h2>Credits:</h2>
                    <p>Building something like this require input from more than a person, and most of the time it's the tech developed by strangers which are a life saver in such situations.</p>
                    <ul>
                        <li>Keshav Aggarwal</li>
                        <p>Redesigning the website</p>
                        <li>Saksham Gupta</li>
                        <p>Dedicated bug hunter... testng the pages using and finding issues.</p>
                        <li>Brendan Eich & Ryan Dahl</li>
                        <p>For creating JavaScript and Node.js</p>
                        <li>Meta & open source community</li>
                        <p>For react and other thousand of packages that holds the site together..</p>
                    </ul>
                </div>
                <div>
                    <h2>Personal Acknowledgement</h2>
                    <p>I would like to thank my <strong>parents</strong> for supporting my passion and providing the device which made programming this website possible. To my <strong>friends</strong> for being the first users of the new games added to this website.</p>
                    <p>I will like to thank all the <strong>users</strong> for trying out the games and coming back to play more.</p>
                    <p>In the last, I will like to thank <strong>Gemini</strong> for helping me give neonDoge3D's ball the look I wanted, because no matter what i do, the ball was appearing to be black. I will also like to thank <strong>ChatGPT</strong> for helping me come up with game ideas for the web.</p>
                </div>
            </div>
        </div>
    );
}